import React from "react";

import styles from "./TextInput.module.scss";
import block from 'bem-css-modules';
import { sanitizeContent as s } from "../../../../util/functions";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { IFieldProperties } from "../InputFields.types";

const TextInput = (props: { fieldData: IFieldProperties, register: UseFormRegister<any>, errors: FieldErrors }) => {
  const { 
    fieldData: {
      label,
      text,
      title,
      placeholder, 
      validationText,
      settings: [{
        crmProperty,
        required,
        validation,
        customValidationRule
      }]
    },
    register,
    errors
  } = props

  const b = block(styles);

  function isValid(value: string): boolean {
    const customRegex = new RegExp(customValidationRule);
    return customRegex.test(value);
  }

  const handleCustomValidation = (value: string) => {
    if (value === "") return true;
    return (validation && customValidationRule) ? isValid(value) : true;
  }

  return (
    <div className={b()}>
      {title && (
        <h3 className={b("title")} dangerouslySetInnerHTML={{ __html: s(title) }}/>
      )}
      {text && <div className={b("text")} dangerouslySetInnerHTML={{ __html: s(text) }} />}
      <input
        id={crmProperty}
        data-crm-field={crmProperty}
        placeholder={placeholder}
        type="text"
        {...register(
          label,
          {
            validate: handleCustomValidation,
            required: required
          }
        )}
      />
      {errors[crmProperty] && (
        <div className={b("error")} dangerouslySetInnerHTML={{ __html: s(validationText) }} />
      )}
    </div>
  )
}

export default TextInput;